<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="aut/letter-pattern/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { LetterPattern } from '@/modules/aut/data/letter-pattern/create'
	import { LetterPatternService } from '@/modules/aut/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return LetterPattern;
			},

			service()
			{
				return new LetterPatternService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>